import { createContext, FC, useContext } from 'react';

import { GetPDPRelatedItemList_pdp_related_item_list_ui_item_list_UxGoodsCardItem as RelatedItem } from '../graphql/related-item-list_types.2';

const ProductCardContext = createContext<RelatedItem>({} as RelatedItem);

interface Props {
  value: RelatedItem;
}

export const ProductCardProvider: FC<React.PropsWithChildren<Props>> = ({ value, children }) => {
  return <ProductCardContext.Provider value={value}>{children}</ProductCardContext.Provider>;
};

export const useProductCardContext = () => useContext(ProductCardContext);
